import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _05fe7dbd = () => interopDefault(import('../pages/achievement/index.vue' /* webpackChunkName: "pages/achievement/index" */))
const _43fa3175 = () => interopDefault(import('../pages/advertise/index.vue' /* webpackChunkName: "pages/advertise/index" */))
const _6ab59b98 = () => interopDefault(import('../pages/agreement/index.vue' /* webpackChunkName: "pages/agreement/index" */))
const _ce4f48f4 = () => interopDefault(import('../pages/calendar/index.vue' /* webpackChunkName: "pages/calendar/index" */))
const _8f94cfb4 = () => interopDefault(import('../pages/customer/index.vue' /* webpackChunkName: "pages/customer/index" */))
const _55c77690 = () => interopDefault(import('../pages/details/index.vue' /* webpackChunkName: "pages/details/index" */))
const _3bf8f34e = () => interopDefault(import('../pages/goals/index.vue' /* webpackChunkName: "pages/goals/index" */))
const _63cd50a9 = () => interopDefault(import('../pages/maisoku/index.vue' /* webpackChunkName: "pages/maisoku/index" */))
const _7e59bb1c = () => interopDefault(import('../pages/media/index.vue' /* webpackChunkName: "pages/media/index" */))
const _b0fd47da = () => interopDefault(import('../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _5742eea7 = () => interopDefault(import('../pages/project/index.vue' /* webpackChunkName: "pages/project/index" */))
const _d559666e = () => interopDefault(import('../pages/response/index.vue' /* webpackChunkName: "pages/response/index" */))
const _21bb87cf = () => interopDefault(import('../pages/sale/index.vue' /* webpackChunkName: "pages/sale/index" */))
const _43fb7226 = () => interopDefault(import('../pages/achievement/output.vue' /* webpackChunkName: "pages/achievement/output" */))
const _5f39681e = () => interopDefault(import('../pages/achievement/registration.vue' /* webpackChunkName: "pages/achievement/registration" */))
const _1f43a889 = () => interopDefault(import('../pages/advertise/analysis.vue' /* webpackChunkName: "pages/advertise/analysis" */))
const _982a1da0 = () => interopDefault(import('../pages/advertise/management.vue' /* webpackChunkName: "pages/advertise/management" */))
const _c5d2d534 = () => interopDefault(import('../pages/advertise/registration.vue' /* webpackChunkName: "pages/advertise/registration" */))
const _ec6db396 = () => interopDefault(import('../pages/calendar/registration.vue' /* webpackChunkName: "pages/calendar/registration" */))
const _e9e714d6 = () => interopDefault(import('../pages/customer/registration.vue' /* webpackChunkName: "pages/customer/registration" */))
const _d2b827e0 = () => interopDefault(import('../pages/goals/analysis.vue' /* webpackChunkName: "pages/goals/analysis" */))
const _092140cc = () => interopDefault(import('../pages/goals/setting.vue' /* webpackChunkName: "pages/goals/setting" */))
const _293a8f00 = () => interopDefault(import('../pages/line/tracking/index.vue' /* webpackChunkName: "pages/line/tracking/index" */))
const _0f273426 = () => interopDefault(import('../pages/maisoku/export.vue' /* webpackChunkName: "pages/maisoku/export" */))
const _726f311a = () => interopDefault(import('../pages/maisoku/template.vue' /* webpackChunkName: "pages/maisoku/template" */))
const _c98858dc = () => interopDefault(import('../pages/response/registration.vue' /* webpackChunkName: "pages/response/registration" */))
const _c040ab58 = () => interopDefault(import('../pages/sale/output.vue' /* webpackChunkName: "pages/sale/output" */))
const _4a9cd56e = () => interopDefault(import('../pages/setting/announcement/index.vue' /* webpackChunkName: "pages/setting/announcement/index" */))
const _b80d3168 = () => interopDefault(import('../pages/setting/import/index.vue' /* webpackChunkName: "pages/setting/import/index" */))
const _1eeb55c8 = () => interopDefault(import('../pages/setting/mail-template.vue' /* webpackChunkName: "pages/setting/mail-template" */))
const _ecb9695a = () => interopDefault(import('../pages/setting/matching-mail.vue' /* webpackChunkName: "pages/setting/matching-mail" */))
const _25ef455a = () => interopDefault(import('../pages/setting/shop.vue' /* webpackChunkName: "pages/setting/shop" */))
const _7615f1af = () => interopDefault(import('../pages/setting/staff/index.vue' /* webpackChunkName: "pages/setting/staff/index" */))
const _70928ee7 = () => interopDefault(import('../pages/setting/step-mail/index.vue' /* webpackChunkName: "pages/setting/step-mail/index" */))
const _0a682ae9 = () => interopDefault(import('../pages/setting/tag/index.vue' /* webpackChunkName: "pages/setting/tag/index" */))
const _23a8415b = () => interopDefault(import('../pages/shop/document-template/index.vue' /* webpackChunkName: "pages/shop/document-template/index" */))
const _1a573094 = () => interopDefault(import('../pages/shop/message/index.vue' /* webpackChunkName: "pages/shop/message/index" */))
const _18135cf0 = () => interopDefault(import('../pages/message/line/edit.vue' /* webpackChunkName: "pages/message/line/edit" */))
const _0fe10d94 = () => interopDefault(import('../pages/message/line/log.vue' /* webpackChunkName: "pages/message/line/log" */))
const _b3c2100c = () => interopDefault(import('../pages/message/line/registration/index.vue' /* webpackChunkName: "pages/message/line/registration/index" */))
const _384b6dfa = () => interopDefault(import('../pages/message/line/select.vue' /* webpackChunkName: "pages/message/line/select" */))
const _425877f4 = () => interopDefault(import('../pages/message/line/send.vue' /* webpackChunkName: "pages/message/line/send" */))
const _bde9480e = () => interopDefault(import('../pages/message/mail/log.vue' /* webpackChunkName: "pages/message/mail/log" */))
const _42ba1f54 = () => interopDefault(import('../pages/message/mail/registration.vue' /* webpackChunkName: "pages/message/mail/registration" */))
const _1084f057 = () => interopDefault(import('../pages/message/mail/select.vue' /* webpackChunkName: "pages/message/mail/select" */))
const _555439a3 = () => interopDefault(import('../pages/message/mail/send.vue' /* webpackChunkName: "pages/message/mail/send" */))
const _b4699166 = () => interopDefault(import('../pages/setting/announcement/registration.vue' /* webpackChunkName: "pages/setting/announcement/registration" */))
const _2b4f2432 = () => interopDefault(import('../pages/setting/import/Detail.vue' /* webpackChunkName: "pages/setting/import/Detail" */))
const _26c320a2 = () => interopDefault(import('../pages/setting/import/registration.vue' /* webpackChunkName: "pages/setting/import/registration" */))
const _45e76ea5 = () => interopDefault(import('../pages/setting/real-estate-agent/property-range.vue' /* webpackChunkName: "pages/setting/real-estate-agent/property-range" */))
const _5146ffec = () => interopDefault(import('../pages/setting/staff/registration.vue' /* webpackChunkName: "pages/setting/staff/registration" */))
const _b5dcd898 = () => interopDefault(import('../pages/setting/step-mail/registration.vue' /* webpackChunkName: "pages/setting/step-mail/registration" */))
const _3d88eaab = () => interopDefault(import('../pages/message/line/registration/success.vue' /* webpackChunkName: "pages/message/line/registration/success" */))
const _0498e5c6 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _6ef60b60 = () => interopDefault(import('../pages/message/mail/edit/_id.vue' /* webpackChunkName: "pages/message/mail/edit/_id" */))
const _5316f935 = () => interopDefault(import('../pages/agreement/log/_id.vue' /* webpackChunkName: "pages/agreement/log/_id" */))
const _7049b20e = () => interopDefault(import('../pages/agreement/registration/_id.vue' /* webpackChunkName: "pages/agreement/registration/_id" */))
const _d792cdde = () => interopDefault(import('../pages/customer/edit/_id.vue' /* webpackChunkName: "pages/customer/edit/_id" */))
const _c0398218 = () => interopDefault(import('../pages/media/registration/_id.vue' /* webpackChunkName: "pages/media/registration/_id" */))
const _25a32f9f = () => interopDefault(import('../pages/project/registration/_id.vue' /* webpackChunkName: "pages/project/registration/_id" */))
const _a9776afa = () => interopDefault(import('../pages/response/add/_id.vue' /* webpackChunkName: "pages/response/add/_id" */))
const _66c54954 = () => interopDefault(import('../pages/setting/announcement/_id.vue' /* webpackChunkName: "pages/setting/announcement/_id" */))
const _5c8293d7 = () => interopDefault(import('../pages/setting/staff/_id.vue' /* webpackChunkName: "pages/setting/staff/_id" */))
const _6d15c1e2 = () => interopDefault(import('../pages/setting/step-mail/_id.vue' /* webpackChunkName: "pages/setting/step-mail/_id" */))
const _58a4df9e = () => interopDefault(import('../pages/shop/message/_id.vue' /* webpackChunkName: "pages/shop/message/_id" */))
const _5cca6936 = () => interopDefault(import('../pages/achievement/_id.vue' /* webpackChunkName: "pages/achievement/_id" */))
const _0da5a400 = () => interopDefault(import('../pages/agreement/_id.vue' /* webpackChunkName: "pages/agreement/_id" */))
const _be7459fc = () => interopDefault(import('../pages/client-history/_id.vue' /* webpackChunkName: "pages/client-history/_id" */))
const _6f1127e4 = () => interopDefault(import('../pages/customer/_id.vue' /* webpackChunkName: "pages/customer/_id" */))
const _374b195a = () => interopDefault(import('../pages/media/_id.vue' /* webpackChunkName: "pages/media/_id" */))
const _4c3a6ecf = () => interopDefault(import('../pages/project/_id.vue' /* webpackChunkName: "pages/project/_id" */))
const _ab013d82 = () => interopDefault(import('../pages/property/_property.vue' /* webpackChunkName: "pages/property/_property" */))
const _caf7355a = () => interopDefault(import('../pages/property/_property/contact/index.vue' /* webpackChunkName: "pages/property/_property/contact/index" */))
const _0e686601 = () => interopDefault(import('../pages/property/_property/contact/confirm.vue' /* webpackChunkName: "pages/property/_property/contact/confirm" */))
const _6999ba17 = () => interopDefault(import('../pages/property/_property/contact/send.vue' /* webpackChunkName: "pages/property/_property/contact/send" */))
const _11afed71 = () => interopDefault(import('../pages/response/_id.vue' /* webpackChunkName: "pages/response/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/achievement",
    component: _05fe7dbd,
    name: "achievement"
  }, {
    path: "/advertise",
    component: _43fa3175,
    name: "advertise"
  }, {
    path: "/agreement",
    component: _6ab59b98,
    name: "agreement"
  }, {
    path: "/calendar",
    component: _ce4f48f4,
    name: "calendar"
  }, {
    path: "/customer",
    component: _8f94cfb4,
    name: "customer"
  }, {
    path: "/details",
    component: _55c77690,
    name: "details"
  }, {
    path: "/goals",
    component: _3bf8f34e,
    name: "goals"
  }, {
    path: "/maisoku",
    component: _63cd50a9,
    name: "maisoku"
  }, {
    path: "/media",
    component: _7e59bb1c,
    name: "media"
  }, {
    path: "/privacy",
    component: _b0fd47da,
    name: "privacy"
  }, {
    path: "/project",
    component: _5742eea7,
    name: "project"
  }, {
    path: "/response",
    component: _d559666e,
    name: "response"
  }, {
    path: "/sale",
    component: _21bb87cf,
    name: "sale"
  }, {
    path: "/achievement/output",
    component: _43fb7226,
    name: "achievement-output"
  }, {
    path: "/achievement/registration",
    component: _5f39681e,
    name: "achievement-registration"
  }, {
    path: "/advertise/analysis",
    component: _1f43a889,
    name: "advertise-analysis"
  }, {
    path: "/advertise/management",
    component: _982a1da0,
    name: "advertise-management"
  }, {
    path: "/advertise/registration",
    component: _c5d2d534,
    name: "advertise-registration"
  }, {
    path: "/calendar/registration",
    component: _ec6db396,
    name: "calendar-registration"
  }, {
    path: "/customer/registration",
    component: _e9e714d6,
    name: "customer-registration"
  }, {
    path: "/goals/analysis",
    component: _d2b827e0,
    name: "goals-analysis"
  }, {
    path: "/goals/setting",
    component: _092140cc,
    name: "goals-setting"
  }, {
    path: "/line/tracking",
    component: _293a8f00,
    name: "line-tracking"
  }, {
    path: "/maisoku/export",
    component: _0f273426,
    name: "maisoku-export"
  }, {
    path: "/maisoku/template",
    component: _726f311a,
    name: "maisoku-template"
  }, {
    path: "/response/registration",
    component: _c98858dc,
    name: "response-registration"
  }, {
    path: "/sale/output",
    component: _c040ab58,
    name: "sale-output"
  }, {
    path: "/setting/announcement",
    component: _4a9cd56e,
    name: "setting-announcement"
  }, {
    path: "/setting/import",
    component: _b80d3168,
    name: "setting-import"
  }, {
    path: "/setting/mail-template",
    component: _1eeb55c8,
    name: "setting-mail-template"
  }, {
    path: "/setting/matching-mail",
    component: _ecb9695a,
    name: "setting-matching-mail"
  }, {
    path: "/setting/shop",
    component: _25ef455a,
    name: "setting-shop"
  }, {
    path: "/setting/staff",
    component: _7615f1af,
    name: "setting-staff"
  }, {
    path: "/setting/step-mail",
    component: _70928ee7,
    name: "setting-step-mail"
  }, {
    path: "/setting/tag",
    component: _0a682ae9,
    name: "setting-tag"
  }, {
    path: "/shop/document-template",
    component: _23a8415b,
    name: "shop-document-template"
  }, {
    path: "/shop/message",
    component: _1a573094,
    name: "shop-message"
  }, {
    path: "/message/line/edit",
    component: _18135cf0,
    name: "message-line-edit"
  }, {
    path: "/message/line/log",
    component: _0fe10d94,
    name: "message-line-log"
  }, {
    path: "/message/line/registration",
    component: _b3c2100c,
    name: "message-line-registration"
  }, {
    path: "/message/line/select",
    component: _384b6dfa,
    name: "message-line-select"
  }, {
    path: "/message/line/send",
    component: _425877f4,
    name: "message-line-send"
  }, {
    path: "/message/mail/log",
    component: _bde9480e,
    name: "message-mail-log"
  }, {
    path: "/message/mail/registration",
    component: _42ba1f54,
    name: "message-mail-registration"
  }, {
    path: "/message/mail/select",
    component: _1084f057,
    name: "message-mail-select"
  }, {
    path: "/message/mail/send",
    component: _555439a3,
    name: "message-mail-send"
  }, {
    path: "/setting/announcement/registration",
    component: _b4699166,
    name: "setting-announcement-registration"
  }, {
    path: "/setting/import/Detail",
    component: _2b4f2432,
    name: "setting-import-Detail"
  }, {
    path: "/setting/import/registration",
    component: _26c320a2,
    name: "setting-import-registration"
  }, {
    path: "/setting/real-estate-agent/property-range",
    component: _45e76ea5,
    name: "setting-real-estate-agent-property-range"
  }, {
    path: "/setting/staff/registration",
    component: _5146ffec,
    name: "setting-staff-registration"
  }, {
    path: "/setting/step-mail/registration",
    component: _b5dcd898,
    name: "setting-step-mail-registration"
  }, {
    path: "/message/line/registration/success",
    component: _3d88eaab,
    name: "message-line-registration-success"
  }, {
    path: "/",
    component: _0498e5c6,
    name: "index"
  }, {
    path: "/message/mail/edit/:id?",
    component: _6ef60b60,
    name: "message-mail-edit-id"
  }, {
    path: "/agreement/log/:id?",
    component: _5316f935,
    name: "agreement-log-id"
  }, {
    path: "/agreement/registration/:id?",
    component: _7049b20e,
    name: "agreement-registration-id"
  }, {
    path: "/customer/edit/:id?",
    component: _d792cdde,
    name: "customer-edit-id"
  }, {
    path: "/media/registration/:id?",
    component: _c0398218,
    name: "media-registration-id"
  }, {
    path: "/project/registration/:id?",
    component: _25a32f9f,
    name: "project-registration-id"
  }, {
    path: "/response/add/:id?",
    component: _a9776afa,
    name: "response-add-id"
  }, {
    path: "/setting/announcement/:id",
    component: _66c54954,
    name: "setting-announcement-id"
  }, {
    path: "/setting/staff/:id",
    component: _5c8293d7,
    name: "setting-staff-id"
  }, {
    path: "/setting/step-mail/:id?",
    component: _6d15c1e2,
    name: "setting-step-mail-id"
  }, {
    path: "/shop/message/:id",
    component: _58a4df9e,
    name: "shop-message-id"
  }, {
    path: "/achievement/:id",
    component: _5cca6936,
    name: "achievement-id"
  }, {
    path: "/agreement/:id",
    component: _0da5a400,
    name: "agreement-id"
  }, {
    path: "/client-history/:id?",
    component: _be7459fc,
    name: "client-history-id"
  }, {
    path: "/customer/:id",
    component: _6f1127e4,
    name: "customer-id"
  }, {
    path: "/media/:id",
    component: _374b195a,
    name: "media-id"
  }, {
    path: "/project/:id",
    component: _4c3a6ecf,
    name: "project-id"
  }, {
    path: "/property/:property?",
    component: _ab013d82,
    name: "property-property",
    children: [{
      path: "contact",
      component: _caf7355a,
      name: "property-property-contact"
    }, {
      path: "contact/confirm",
      component: _0e686601,
      name: "property-property-contact-confirm"
    }, {
      path: "contact/send",
      component: _6999ba17,
      name: "property-property-contact-send"
    }]
  }, {
    path: "/response/:id",
    component: _11afed71,
    name: "response-id"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
